// eslint-disable-next-line
import React from 'react';
import { RadioButton as Ap4Radio } from '@cb/apricot-react';

export default function RadioButton(props) {
  return <Ap4Radio labelClassName='tdtk-radio-label' {...props} />;
}
